export const inr = (n: number | string) =>
  "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export const inrPrecise = (n: number | string) =>
  "₹" + Number(n).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function calcEmi(principal: number, annualRatePct: number, months: number): number {
  const r = annualRatePct / 12 / 100;
  if (!principal || !months) return 0;
  if (r === 0) return principal / months;
  return (principal * r * Math.pow(1 + r, months)) / (Math.pow(1 + r, months) - 1);
}

export function riskColor(grade: string): string {
  switch (grade) {
    case "A":
      return "bg-success/15 text-success border-success/30";
    case "B":
      return "bg-accent/15 text-accent-foreground border-accent/30";
    case "C":
      return "bg-warning/15 text-warning-foreground border-warning/30";
    default:
      return "bg-muted text-muted-foreground border-border";
  }
}
